/*eslint no-undef: "off"*/

// Children of ViewAuthenticated for the data-ops zone.
//
// The zone supplies its own chrome (DataOpsNav) instead of the product sidebar.
// AuthenticatedView skips mounting LeftNavigation for any `/data-ops` path.
// Detection is path-based rather than route-name based so `/sources` routes can
// be re-parented under `/data-ops` later without renaming every route.
export const dataOpsRoutes = [
    {
        path: 'data-ops',
        component: () => import('@/features/data-ops/views/DataOpsRouterView.vue'),
        meta: { title: 'Data Ops' },
        beforeEnter() {
            const currentUser = useCurrentUserStore()

            if (!currentUser.isAdmin) return { path: '/home' }
        },
        children: [
            {
                path: '',
                redirect: { name: 'data-ops-summary' },
            },
            {
                path: 'summary',
                name: 'data-ops-summary',
                meta: { title: 'Summary' },
                component: () => import('@/features/data-ops/views/DataOpsSummaryView.vue'),
            },
            {
                path: 'overview',
                name: 'data-ops-overview',
                meta: { title: 'Overview' },
                component: () => import('@/features/data-ops/views/DataOpsOverviewView.vue'),
            },
        ],
    },
]
